import React, { useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { localApi, catApi, roundUp } from "utils/imgApi";
import { useHistory, useLocation } from "react-router-dom";
import { BiFile } from "react-icons/bi";
import { makeStyles } from "@material-ui/core/styles";
import Selects from "react-select";
import InputLabel from "@material-ui/core/InputLabel";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import AddIcon from "@material-ui/icons/Add";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import { FaBox, FaRing, FaUsers } from "react-icons/fa";
import { GiWireCoil, GiBoxUnpacking } from "react-icons/gi";
import { BsImages } from "react-icons/bs";
import { AiOutlineCalculator } from "react-icons/ai";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styRadio from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styCheckbox from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(styRadio);
const useStyl = makeStyles(styDrop);
const useSty = makeStyles(styCheckbox);
const useStyleSweet = makeStyles(styleSweet);

export default function LeadsAdd(props) {
  const [itemClient, setItemClient] = React.useState([]);
  const [itemProd, setItemProd] = React.useState([]);
  const [items, setItems] = React.useState([]);
  const [items1, setItems1] = React.useState([]);
  const [items2, setItems2] = React.useState([]);
  const [itemSets, setItemSets] = React.useState([]);
  const [itemBox, setItemBox] = React.useState([]);
  const [metal, setMetal] = React.useState([]);
  const [plastic, setPlastic] = React.useState([]);
  const [crystal, setCrystal] = React.useState([]);
  const [ploythene, setPloythene] = React.useState([]);
  const [simpleProductSelect, setSimpleProductSelect] = React.useState("");
  const [imgList, setImgList] = React.useState("");
  const [imgListMore, setImgListMore] = React.useState("");
  const [newImage, setNewImage] = React.useState(false);
  const [simpleSelectProd, setSimpleSelectProd] = React.useState("");
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelect1, setSimpleSelect1] = React.useState("");
  const [selectedGstCal, setSelectedGstCal] = React.useState("cash");
  const [selectedGstCalTax, setSelectedGstCalTax] = React.useState("local");
  const [checkedA, setCheckedA] = React.useState(false);
  const [checkedTax, setCheckedTax] = React.useState(false);
  const [selectedProfit, setSelectedProfit] = React.useState("profit");
  const [selectedPieceSets, setSelectedPieceSets] = React.useState(0);
  const [selectedBox, setSelectedBox] = React.useState(0);
  const [makingCheckboxMaking, setMakingCheckboxMaking] = React.useState("");
  const [simpleSelectMetal, setSimpleSelectMetal] = React.useState("");
  const [readyGram, setReadyGram] = React.useState("0.0075");
  const [metalGram, setMetalGram] = React.useState("0.0100");
  const [metalSGram, setMetalSGram] = React.useState("0.0005");
  const [golwireThaw, setGolwireThaw] = React.useState("100 Thaw Golwire");
  const [packingOption, setPackingOption] = React.useState("");
  const [simpleSelectPlastic, setSimpleSelectPlastic] = React.useState("");
  const [simpleSelectCrystal, setSimpleSelectCrystal] = React.useState("");
  const [simpleSelectPloythene, setSimpleSelectPloythene] = React.useState("");
  const [checkBoxMaking, setCheckBoxmaking] = React.useState([]);
  const [makingSingleId, setMakingSingleId] = React.useState("");
  const [includeGST, setIncludeGST] = React.useState(0);
  const [includeSets, setIncludeSets] = React.useState(0);
  const [totalCash, setTotalCash] = React.useState(0);
  const [sets, setSets] = React.useState(0);
  const [prodItemCode, setProdItemCode] = React.useState("");
  const [boxUnit, setBoxUnit] = React.useState("Box");
  const [ctnUnit, setCtnUnit] = React.useState("CTN");
  const [prodDescription, setProdDescription] = React.useState("");
  const [prodMfgDetails, setProdMfgDetails] = React.useState("");
  const [cartonDescription, setCartonDescription] = React.useState(
    "96 boxes of in 1 Carton",
  );
  const [cartonQuantity, setCartonQuantity] = React.useState("1");
  const [cartonPackingCharge, setCartonPackingCharge] = React.useState(
    "500.00",
  );
  const [makingPrice, setMakingPrice] = React.useState(0);
  const [makingGst, setMakingGst] = React.useState(0);
  const [makIncludeGst, setMakIncludeGst] = React.useState(0);
  const [metalPrice, setMetalPrice] = React.useState(0);
  const [metalDiff, setMetalDiff] = React.useState(0);
  const [metalGst, setMetalGst] = React.useState(0);
  const [plasticPrice, setPlasticPrice] = React.useState(0);
  const [plasticGst, setPlasticGst] = React.useState(0);
  const [plasticDesc, setPlasticDesc] = React.useState("");
  const [plasticHsncode, setPlasticHsncode] = React.useState("");
  const [plasticActive, setPlasticActive] = React.useState("");
  const [crystalPrice, setCrystalPrice] = React.useState(0);
  const [crystalGst, setCrystalGst] = React.useState(0);
  const [crystalDesc, setCrystalDesc] = React.useState("");
  const [crystalHsncode, setCrystalHsncode] = React.useState("");
  const [crystalActive, setCrystalActive] = React.useState("");
  const [ployPrice, setPloyPrice] = React.useState(0);
  const [ployGst, setPloyGst] = React.useState(0);
  const [ployDesc, setPloyDesc] = React.useState("");
  const [ployHsncode, setPloyHsncode] = React.useState("");
  const [ployActive, setPloyActive] = React.useState("");
  const [makChecked, setMakChecked] = React.useState("");
  const [boxVal, setBoxVal] = React.useState(0);
  const [platVal, setPlatVal] = React.useState(0);
  const [makVal, setMakVal] = React.useState(0);
  const [metGramVal, setMetGramVal] = React.useState(0);
  const [packVal, setPackVal] = React.useState(0);

  const [totalProfit, setTotalProfit] = React.useState(0);
  const [setProfit, setSetProfit] = React.useState(0);

  const [includeProfit, setIncludeProfit] = React.useState(0);
  const [includeProfitSet, setIncludeProfitSet] = React.useState(0);

  const [tax, setTax] = React.useState("0");

  const [catDes, setCatDes] = React.useState("");
  const [parentDes, setParentDes] = React.useState("");
  const [prdId, setPrdID] = React.useState("");

  const [clientid, setClientid] = React.useState("");
  const [simpleSelectClient, setSimpleSelectClient] = React.useState("");

  const [cat, setCat] = React.useState("");
  const [catSize, setCatSize] = React.useState("");
  const [checkBoxImage, setCheckBoxImage] = React.useState([]);
  const [makingCheckboxImage, setMakingCheckboxImage] = React.useState("");
  const [imgChecked, setImgChecked] = React.useState("");

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [comment, setComment] = React.useState(
    "Mix different four sizes in one design, or mix different six designs in one size, or one design in one size.",
  );

  const [size1x8, setSize1x8] = React.useState(0);
  const [size1x9, setSize1x9] = React.useState(0);
  const [size1x10, setSize1x10] = React.useState(0);
  const [size1x11, setSize1x11] = React.useState(0);
  const [size1x12, setSize1x12] = React.useState(0);
  const [size1x13, setSize1x13] = React.useState(0);
  const [size1x14, setSize1x14] = React.useState(0);
  const [size1x15, setSize1x15] = React.useState(0);
  const [size2x0, setSize2x0] = React.useState(0);
  const [size2x1, setSize2x1] = React.useState(0);
  const [size2x2, setSize2x2] = React.useState(0);
  const [size2x3, setSize2x3] = React.useState(0);
  const [size2x4, setSize2x4] = React.useState(0);
  const [size2x5, setSize2x5] = React.useState(0);
  const [size2x6, setSize2x6] = React.useState(0);
  const [size2x7, setSize2x7] = React.useState(0);
  const [size2x8, setSize2x8] = React.useState(0);
  const [size2x9, setSize2x9] = React.useState(0);
  const [size2x10, setSize2x10] = React.useState(0);
  const [size2x11, setSize2x11] = React.useState(0);
  const [size2x12, setSize2x12] = React.useState(0);
  const [size2x13, setSize2x13] = React.useState(0);
  const [size2x14, setSize2x14] = React.useState(0);
  const [size2x15, setSize2x15] = React.useState(0);
  const [size3x0, setSize3x0] = React.useState(0);
  const [size3x1, setSize3x1] = React.useState(0);
  const [checkedCutSize, setCheckedCutSize] = React.useState(false);
  const [checkedFullSize, setCheckedFullSize] = React.useState(false);
  const [fullCutTotalErr, setFullCutTotalErr] = React.useState("");

  const [igst, setIgst] = React.useState("");
  const [cgst, setCgst] = React.useState("");
  const [sgst, setSgst] = React.useState("");

  const [metals, setMetals] = React.useState("");

  const [metalDetails, setMetalDetails] = React.useState("");
  const [boxDetails, setBoxDetails] = React.useState("");
  const [plasticDetails, setPlasticDetails] = React.useState("");
  const [crystalDetails, setCrytalDetail] = React.useState("");
  const [polytheneDetails, setPolytheneDetail] = React.useState("");

  const [clientDetails, setClientDetails] = React.useState("");

  const [simpleSelectClientErr, setSimpleSelectClientErr] = React.useState("");
  const [simpleSelectProdErr, setSimpleSelectProdErr] = React.useState("");
  const [newAddCart, setNewAddCart] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const [hsnCode, setHsnCode] = React.useState("7117");
  const [hsnCodeErr, setHsnCodeErr] = React.useState("");

  const [imageId, setImageId] = React.useState("");
  const [crtId, setCrtId] = React.useState("");
  const [imageObject, setImageObject] = React.useState("");
  const [cartDetails, setCartDetails] = React.useState("");

  const [ordId, setOrdId] = React.useState("");
  const [ordCartIds, setOrdCartIds] = React.useState([]);

  const [packingPrice, setPackingPrice] = React.useState("");
  const [boxPkgCharge, setBoxPkgCharge] = React.useState("");
  const [boxInput, setBoxInput] = React.useState("");
  const [inputValues, setInputValues] = React.useState({});
  const [isCheckedMaking, setIsCheckedMaking] = React.useState(false);
  const [isCheckedMetal, setIsCheckedMetal] = React.useState(false);
  const [isCheckedPacking, setIsCheckedPacking] = React.useState(false);
  const [isAllCheckedErr, setIsAllCheckedErr] = React.useState("");
  const [makingChargeErr, setMakingChargeErr] = React.useState("");
  const [lbrChild, setLbrChild] = React.useState([]);

  const classes = useStyles();
  const classesRadio = useStyle();
  const classe = useStyl();
  const classCheck = useSty();
  const classSweet = useStyleSweet();
  const history = useHistory();

  let { avatar } = props;

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const { state } = useLocation();
  const cart = state?.cart;

  const cleanDecimalInput = (text) => {
    return text.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  };

  useEffect(() => {
    if (!cart) {
      history.replace("/admin/leadsList");
      return;
    }

    const loadCartData = async () => {
      const itCart = cart;
      // console.log(itCart);

      setCartDetails(itCart);
      setCrtId(itCart.id);
      setSimpleSelectProd(itCart.pId);
      setSimpleSelect(itCart.categoryId);
      setCatDes(itCart.categoryTitle);

      setImageId(itCart.cartImage?.[0]?.cpanelPath || "");
      setImageObject(itCart.cartImage?.[0] || "");

      axios
        .get(localApi + `/parent/list/byCategoryId/${itCart.categoryId}`, {
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        })
        .then((res) => setItems1(res.data));

      setSimpleSelect1(itCart.parentId);
      setParentDes(itCart.parentTitle);

      const setsObj = {
        id: itCart.setsId,
        setDesc: itCart.setsDesc,
        pcs: Number(itCart.setsPcs || 0),
      };
      setSelectedPieceSets(setsObj);

      const boxObj = {
        id: itCart.boxId,
        brandName: itCart.boxBrandName,
        boxDesc: itCart.boxDesc,
        pkgCharge: Number(itCart.boxPkgCharge || 0),
        box: Number(itCart.box || 0),
        hsnCode: itCart.boxHsnCode,
        price: Number(itCart.boxPrice || 0),
        tax_percentage: Number(itCart.boxTaxPercentage || 0),
      };
      setSelectedBox(boxObj);

      let boxVa = 0;
      let boxLoadGst = 0;

      if (itCart.boxId) {
        boxVa = Number(itCart.boxPrice || 0) + Number(itCart.boxPkgCharge || 0);
        boxLoadGst =
          (Number(itCart.boxPrice || 0) *
            Number(itCart.boxTaxPercentage || 0)) /
          100;

        setBoxVal(boxVa.toFixed(2));
      }

      const cApi = localApi + `/child/list/byParentId/${itCart.parentId}`;
      const cRresult = await fetch(cApi, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });

      const getC = await cRresult.json();
      setItems2(getC || []);

      let tempPrice = 0;
      let tempMakVal = 0;
      let tempMakGstVal = 0;
      let tempMakGst = 0;
      setCheckBoxmaking(
        cart.cartChild.map((ltist) => {
          tempPrice += ltist.price;
          tempMakVal += ltist?.price * cart.setsPcs * cart.box;
          tempMakGstVal += ltist.tax * cart.setsPcs * cart.box;
          tempMakGst += ltist.tax;
          return ltist.lbrId;
        }),
      );

      setLbrChild(cart.cartChild);

      setMakingPrice(tempPrice);
      // setMakVal(tempMakVal);
      setMakIncludeGst(tempMakGst);

      setSimpleSelectMetal(itCart.rawId);

      const rawObj = {
        id: itCart.rawId,
        title: itCart.rawTitle,
        price: Number(itCart.rawPrice || 0),
        different: Number(itCart.rawDifferent || 0),
        tax: Number(itCart.rawTax || 0),
        taxPercentage: Number(itCart.rawTaxPercentage || 0),
      };

      setMetalDetails(rawObj);
      setMetalPrice(Number(itCart.rawPrice || 0));
      setMetalDiff(Number(itCart.rawDifferent || 0));
      setMetalGst(Number(itCart.rawTaxPercentage || 0));

      setMetalGram(itCart.metalGram || "0");
      setReadyGram(itCart.readyGram || "0");
      setMetalSGram(itCart.extraGram || "0");
      setGolwireThaw(itCart.golwireThaw || "");

      let newMet = 0;
      let metLoadGst = 0;

      if (itCart.metalGram) {
        newMet =
          Number(itCart.metalGram || 0) *
          Number(itCart.setsPcs || 0) *
          Number(itCart.box || 0) *
          Number(itCart.rawPrice || 0);

        metLoadGst = (newMet * Number(itCart.rawTaxPercentage || 0)) / 100;

        setMetGramVal(newMet.toFixed(2));
      }

      setPackingOption(itCart.packingType);

      let ployTotal = 0;
      let packLoadGst = 0;

      if (itCart.packingId) {
        ployTotal =
          Number(itCart.packingPrice || 0) * Number(itCart.box || 0) +
          Number(itCart.boxPkgCharge || 0) +
          Number(itCart.boxPrice || 0);

        packLoadGst =
          (Number(itCart.packingPrice || 0) *
            Number(itCart.box || 0) *
            Number(itCart.packingLigst || 0)) /
          100;

        setPackVal(ployTotal.toFixed(2));
      }

      const pObj = {
        id: itCart.packingId,
        type: itCart.packingType,
        pkgdesc: itCart.packingDesc,
        hsncode: itCart.packingHsncode,
        price: Number(itCart.packingPrice || 0),
        ligst: Number(itCart.packingLigst || 0),
        pdp: itCart.packingDesc + " - " + itCart.packingPrice,
      };

      if (itCart.packingType === "Crystal Dibbi") {
        axios
          .get(
            localApi +
              `/packingmaterial/list/byAdminIdAndType/${
                userObj && userObj.id
              }/Crystal Dibbi`,
            {
              headers: {
                Authorization: `Basic ${credentials}`,
              },
            },
          )
          .then((res) => setCrystal(res && res.data));

        setSimpleSelectCrystal(itCart.packingId);
        setCrystalPrice(Number(itCart.packingPrice || 0));
        setCrystalGst(Number(itCart.packingLigst || 0));
        setCrystalDesc(itCart.packingDesc);
        setCrystalHsncode(itCart.packingHsncode);
        setCrytalDetail(pObj);
      }

      if (itCart.packingType === "Polythene Bag") {
        axios
          .get(
            localApi +
              `/packingmaterial/list/byAdminIdAndType/${
                userObj && userObj.id
              }/Polythene Bag`,
            {
              headers: {
                Authorization: `Basic ${credentials}`,
              },
            },
          )
          .then((res) => setPloythene(res && res.data));

        setSimpleSelectPloythene(itCart.packingId);
        setPloyPrice(Number(itCart.packingPrice || 0));
        setPloyGst(Number(itCart.packingLigst || 0));
        setPloyDesc(itCart.packingDesc);
        setPloyHsncode(itCart.packingHsncode);
        setPolytheneDetail(pObj);
      }

      if (itCart.packingType === "Plastic Dibbi") {
        axios
          .get(
            localApi +
              `/packingmaterial/list/byAdminIdAndType/${
                userObj && userObj.id
              }/Plastic Dibbi`,
            {
              headers: {
                Authorization: `Basic ${credentials}`,
              },
            },
          )
          .then((res) => setPlastic(res && res.data));

        setSimpleSelectPlastic(itCart.packingId);
        setPlasticPrice(Number(itCart.packingPrice || 0));
        setPlasticGst(Number(itCart.packingLigst || 0));
        setPlasticDesc(itCart.packingDesc);
        setPlasticHsncode(itCart.packingHsncode);
        setPlasticDetails(pObj);
      }

      const boxPTotalCash = boxVa + tempMakVal + newMet + ployTotal;
      const boxPTotalGst =
        boxLoadGst + tempMakGstVal + metLoadGst + packLoadGst;

      setTax(roundUp(boxPTotalGst, 2));

      const includeGstTotal = boxPTotalCash + roundUp(boxPTotalGst, 2);
      setIncludeGST(roundUp(includeGstTotal, 2));
      setIncludeSets(roundUp(includeGstTotal / Number(itCart.box || 1), 2));

      const profitGst =
        (boxPTotalCash * Number(userObj?.profit || 0)) / 100 +
        roundUp(boxPTotalGst, 2) +
        boxPTotalCash;

      setIncludeProfit(roundUp(profitGst, 2));
      setIncludeProfitSet(roundUp(profitGst / Number(itCart.box || 1), 2));

      setTotalCash(boxPTotalCash.toFixed(2));
      setSets(roundUp(boxPTotalCash / Number(itCart.box || 1), 2));

      const profitCash =
        (boxPTotalCash * Number(userObj?.profit || 0)) / 100 +
        boxPTotalCash +
        roundUp(boxPTotalGst, 2) / 2;

      setTotalProfit(roundUp(profitCash, 2));
      setSetProfit(roundUp(profitCash / Number(itCart.box || 1), 2));

      setProdItemCode(itCart.itemCodeNumber);
      setBoxUnit(itCart.boxUnit);
      setCtnUnit(itCart.ctnUnit);
      setProdMfgDetails(itCart.prodManfDetails);
      setProdDescription(itCart.prodDescription);
      setCartonDescription(itCart.cartDescription);
      setCartonQuantity(itCart.cartQuantity);
      setCartonPackingCharge(itCart.cartPackCharge);
      setCheckedA(itCart.active);
      setComment(itCart.comment);
      setHsnCode(itCart.hsnSacCode);

      setSelectedGstCal(itCart.gstCash === true ? "gst" : "cash");
      setCheckedTax(itCart.taxApply);
      setCgst(itCart.cgst);
      setSgst(itCart.sgst);
      setIgst(itCart.igst);
      setSelectedGstCalTax(itCart.saleType == 0 ? "local" : "interested");

      setSize1x8(itCart.size1x8);
      setSize1x9(itCart.size1x9);
      setSize1x10(itCart.size1x10);
      setSize1x11(itCart.size1x11);
      setSize1x12(itCart.size1x12);
      setSize1x13(itCart.size1x13);
      setSize1x14(itCart.size1x14);
      setSize1x15(itCart.size1x15);
      setSize2x0(itCart.size2x0);
      setSize2x1(itCart.size2x1);
      setSize2x2(itCart.size2x2);
      setSize2x3(itCart.size2x3);
      setSize2x4(itCart.size2x4);
      setSize2x5(itCart.size2x5);
      setSize2x6(itCart.size2x6);
      setSize2x7(itCart.size2x7);
      setSize2x8(itCart.size2x8);
      setSize2x9(itCart.size2x9);
      setSize2x10(itCart.size2x10);
      setSize2x11(itCart.size2x11);
      setSize2x12(itCart.size2x12);
      setSize2x13(itCart.size2x13);
      setSize2x14(itCart.size2x14);
      setSize2x15(itCart.size2x15);
      setSize3x0(itCart.size3x0);
      setSize3x1(itCart.size3x1);
    };

    loadCartData();
  }, [cart, history]);

  const totalPiece = "18";
  //   Math.ceil("864" / sets.pcs / box.box);

  // Helper function to round up to 2 decimal places
  // const roundUp = (num, decimals) => {
  //   const factor = Math.pow(10, decimals);
  //   return Math.ceil(num * factor) / factor;
  // };

  async function getUserClient() {
    const api =
      localApi + `/clientGroup/list/byAdminId/${userObj && userObj.id}`;
    const results = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResults = await results.json();
    setItemClient(getResults && getResults.filter((f) => f.type != "Crm"));
    // console.log(getResults);
  }

  useEffect(() => {
    getUserClient();
  }, []);

  const handleCheckBoxMaking = (making) => {
    const id = making.id || making.lbrId;

    setLbrChild((prev) => {
      const updatedList = prev.map((item) => {
        const itemId = item.id || item.lbrId;

        if (itemId === id) {
          return {
            ...item,
            id: itemId,
            checked: !item.checked,
          };
        }

        return item;
      });

      calculateMaking(updatedList);
      return updatedList;
    });
  };

  const calculateMaking = (list) => {
    const pcs = Number(selectedPieceSets?.pcs || cartDetails?.setsPcs || 0);
    const box = Number(selectedBox?.box || cartDetails?.box || 0);

    const checkedList = list.filter((item) => item.checked === true);

    const totalMakingPrice = checkedList.reduce(
      (total, item) => total + Number(item.price || 0),
      0,
    );

    const totalMakingTax = checkedList.reduce(
      (total, item) => total + Number(item.tax || 0),
      0,
    );

    setMakingPrice(totalMakingPrice);
    setMakVal(totalMakingPrice * pcs * box);
    setMakIncludeGst(totalMakingTax);
    setCheckBoxmaking(checkedList.map((item) => item.id || item.lbrId));
  };

  const handleCheckboxInputChild = (id, value) => {
    const cleanValue = cleanDecimalInput(value);

    setInputValues((prev) => ({
      ...prev,
      [id]: cleanValue,
    }));

    setLbrChild((prev) => {
      const updatedList = prev.map((item) => {
        const itemId = item.id || item.lbrId;

        if (itemId === id) {
          const price = cleanValue === "" ? 0 : Number(cleanValue);
          const taxPercentage = Number(item.taxPercentage || 0);

          return {
            ...item,
            id: itemId,
            price,
            tax: (price * taxPercentage) / 100,
          };
        }

        return item;
      });

      calculateMaking(updatedList);
      return updatedList;
    });
  };

  const handleClient = async (simpleSelectClient) => {
    if (simpleSelectClient.value) {
      let newSpli = simpleSelectClient.value.split("-");
      const ids = itemClient.find((f) => f.mobile === newSpli[1]);

      setClientDetails(ids);
      setClientid(ids.id);
    }

    setSimpleSelectClient(simpleSelectClient);
    setSimpleSelectClientErr("");
    setNewAddCart(false);
  };

  const SubmitLeadsAdd = () => {
    const selectedLbrChild = lbrChild.filter((item) => item.checked === true);

    setNewAddCart(false);
    setSimpleSelectClientErr("");
    setIsAllCheckedErr("");
    setMakingChargeErr("");

    // Making / Metal / Packing validation
    if (!isCheckedMaking && !isCheckedMetal && !isCheckedPacking) {
      setNewAddCart(true);
      setIsAllCheckedErr("Please select Making, Metal or Packing.");
      return;
    }

    // Making child validation
    if (isCheckedMaking && selectedLbrChild.length === 0) {
      setNewAddCart(true);
      setMakingChargeErr("Please select at least one making charge.");
      return;
    }

    // Client validation
    if (
      !simpleSelectClient ||
      simpleSelectClient === "" ||
      !simpleSelectClient
    ) {
      setNewAddCart(true);
      setSimpleSelectClientErr("Please select Company & Client Name.");
      return;
    }

    const metalData = isCheckedMetal
      ? {
          id: cartDetails.id,
          metalTitle: cartDetails.rawTitle,
          metalPrice: metals !== "" ? metals : metalPrice,
          readyGram,
          metalGram,
          metalSGram,
          golwireThaw,
          metalGramValBox: metGramVal,
        }
      : null;

    const packingData = isCheckedPacking
      ? {
          id: cartDetails.id,
          packingOption,
          packVal,
          boxBrandName: cartDetails?.boxBrandName,
          boxDesc: cartDetails?.boxDesc,
          box: cartDetails?.box,
          boxPkgCharge: boxPkgCharge ? boxPkgCharge : cartDetails?.boxPkgCharge,
          boxPrice: boxInput ? boxInput : cartDetails?.boxPrice,
          setsDesc: cartDetails?.setsDesc,
          setsPcs: cartDetails?.setsPcs,
          cartDescription: cartDetails?.cartDescription,
          cartQuantity: cartDetails?.cartQuantity,
          comment: cartDetails?.comment,
          itemCodeNumber: cartDetails?.itemCodeNumber,
          packingDesc: cartDetails?.packingDesc,
          price: packingPrice ? packingPrice : cartDetails?.packingPrice,
        }
      : null;

    const sizeDataTotal = {
      size1x10: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x10,
      size1x11: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x11,
      size1x12: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x12,
      size1x13: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x13,
      size1x14: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x14,
      size1x15: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x15,
      size1x8: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x8,
      size1x9: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size1x9,

      size2x0: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x0,
      size2x1: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x1,
      size2x10: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x10,
      size2x11: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x11,
      size2x12: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x12,
      size2x13: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x13,
      size2x14: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x14,
      size2x15: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x15,
      size2x2: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x2,
      size2x3: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x3,
      size2x4: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x4,
      size2x5: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x5,
      size2x6: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x6,
      size2x7: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x7,
      size2x8: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x8,
      size2x9: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size2x9,

      size3x0: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size3x0,
      size3x1: cartDetails?.setsPcs * cartDetails?.box * cartDetails.size3x1,
    };

    const sizeData = {
      size1x10: cartDetails.size1x10,
      size1x11: cartDetails.size1x11,
      size1x12: cartDetails.size1x12,
      size1x13: cartDetails.size1x13,
      size1x14: cartDetails.size1x14,
      size1x15: cartDetails.size1x15,
      size1x8: cartDetails.size1x8,
      size1x9: cartDetails.size1x9,

      size2x0: cartDetails.size2x0,
      size2x1: cartDetails.size2x1,
      size2x10: cartDetails.size2x10,
      size2x11: cartDetails.size2x11,
      size2x12: cartDetails.size2x12,
      size2x13: cartDetails.size2x13,
      size2x14: cartDetails.size2x14,
      size2x15: cartDetails.size2x15,
      size2x2: cartDetails.size2x2,
      size2x3: cartDetails.size2x3,
      size2x4: cartDetails.size2x4,
      size2x5: cartDetails.size2x5,
      size2x6: cartDetails.size2x6,
      size2x7: cartDetails.size2x7,
      size2x8: cartDetails.size2x8,
      size2x9: cartDetails.size2x9,

      size3x0: cartDetails.size3x0,
      size3x1: cartDetails.size3x1,
    };

    // SUM ALL VALUES
    const total = Object.values(sizeData).reduce((sum, value) => {
      return sum + (parseFloat(value) || 0);
    }, 0);

    setBtn(true);

    // console.log({
    //   clientid,
    //   clientDetails,
    //   cartDetails,
    //   selectedLbrChild,
    //   isCheckedMaking,
    //   isCheckedMetal,
    //   isCheckedPacking,
    //   metalData,
    //   packingData,
    //   sizeDataTotal,
    //   sizeData,
    //   total,
    // });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Basic ${credentials}`,
      },
      body: JSON.stringify({
        adminId: cartDetails.c_adminid,
        jobClientId: clientDetails.id,
        cartId: cartDetails.id,
        productId: cartDetails.pId,
        categoryTitle: cartDetails.categoryTitle,
        sizeMMTitle: cartDetails.parentTitle,
        imageId: imageObject.imgId,
        imageUrl: cartDetails.cartImage[0].cpanelPath,
        imageList: JSON.stringify(cartDetails.cartImage),
        cartDescription: cartDetails.cartDescription,
        cartPackCharge: cartDetails.cartPackCharge,
        cartQuantity: cartDetails.cartQuantity,
        itemCodeNumber: cartDetails.itemCodeNumber,
        comment: cartDetails.comment,
        setsPcs: cartDetails.setsPcs,
        box: cartDetails.box,

        making: isCheckedMaking,
        labourList: JSON.stringify(isCheckedMaking ? selectedLbrChild : []),

        metal: isCheckedMetal,
        metalData: JSON.stringify(isCheckedMetal ? [metalData] : []),

        packing: isCheckedPacking,
        packingData: JSON.stringify(isCheckedPacking ? [packingData] : []),

        sizeData: JSON.stringify([sizeDataTotal] || []),
        sizeTotal: total * cartDetails?.setsPcs * cartDetails?.box,
      }),
    };

    fetch(localApi + `/jobcart/addRN`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        if (data.message === "Data Inserted Successfully !!!") {
          const bodyData = {
            metalIssue: isCheckedMetal
              ? isCheckedMetal
              : cartDetails.metalIssue,
            lbrIssue: isCheckedMaking ? isCheckedMaking : cartDetails.lbrIssue,
            pkgIssue: isCheckedPacking
              ? isCheckedPacking
              : cartDetails.pkgIssue,
          };
          axios
            .put(
              `${localApi}/cart/update/jobCart/byAdminAndCartId/${cartDetails.c_adminid}/${cartDetails.id}`,
              bodyData, // Empty body if you don't need to send any data in the PUT request body
              {
                headers: {
                  Authorization: `Basic ${credentials}`,
                },
              },
            )
            .then((res) => {
              // console.log(res.data);
              if (res.data.message === "Data Updated Successfully !!!") {
                alertTypeOps("success");
                alertMsgOps("Succesfully Added !!!");
                setSubmitted(true);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          alertTypeOps("danger");
          alertMsgOps("Something went wrong !!!");
          setSubmitted(true);
        }
      });
  };

  useEffect(() => {
    const pcs = Number(selectedPieceSets?.pcs || 0);
    const box = Number(selectedBox?.box || 0);

    const checkedList = lbrChild.filter((item) => item.checked === true);

    const totalMakingPrice = checkedList.reduce(
      (total, item) => total + Number(item.price || 0),
      0,
    );

    const totalMakingTax = checkedList.reduce(
      (total, item) => total + Number(item.tax || 0),
      0,
    );

    setMakingPrice(totalMakingPrice);
    setMakVal(totalMakingPrice * pcs * box);
    setMakIncludeGst(totalMakingTax);
    setCheckBoxmaking(checkedList.map((item) => item.id || item.lbrId));

    const gram = Number(metalGram || 0);
    const price =
      metals !== "" && !isNaN(metals)
        ? Number(metals)
        : Number(metalPrice || 0);

    setMetGramVal((gram * pcs * box * price).toFixed(2));

    const currentBoxPrice = Number(
      boxInput !== ""
        ? boxInput
        : cartDetails?.boxPrice || selectedBox?.price || 0,
    );

    const currentBoxPkgCharge = Number(
      boxPkgCharge !== ""
        ? boxPkgCharge
        : cartDetails?.boxPkgCharge || selectedBox?.pkgCharge || 0,
    );

    let currentPackingPrice = 0;

    if (packingOption === "Plastic Dibbi") {
      currentPackingPrice = Number(
        packingPrice !== "" ? packingPrice : plasticPrice || 0,
      );
    } else if (packingOption === "Crystal Dibbi") {
      currentPackingPrice = Number(
        packingPrice !== "" ? packingPrice : crystalPrice || 0,
      );
    } else if (packingOption === "Polythene Bag") {
      currentPackingPrice = Number(
        packingPrice !== "" ? packingPrice : ployPrice || 0,
      );
    }

    setPackVal(
      (
        currentPackingPrice * box +
        currentBoxPrice +
        currentBoxPkgCharge
      ).toFixed(2),
    );
  }, [
    lbrChild,
    inputValues,
    selectedPieceSets,
    selectedBox,
    boxInput,
    boxPkgCharge,
    packingPrice,
    plasticPrice,
    crystalPrice,
    ployPrice,
    packingOption,
    metalGram,
    metals,
    metalPrice,
    cartDetails,
  ]);

  const hideAlert = () => {
    setSubmitted(false);
    // window.location.reload(false);
    history.push("/admin/leadsList");
  };

  const select = {
    width: "100%",
    maxWidth: 600,
  };

  const mystyle = {
    position: "fixed",
    bottom: "10px",
    right: "30px",
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
    }),
    menu: (state) => ({
      color: "#d81b60",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Leads Cart</small>
                {newAddCart === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectClientErr ||
                      isAllCheckedErr ||
                      makingChargeErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    {/* Select Product Id */}
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >
                    Added Job Cart
                  </SweetAlert>
                ) : null}

                <GridItem xs={12} sm={12} md={12}>
                  <label className={classe.selectLabel}>
                    Category: <strong>{catDes}</strong>
                  </label>
                  <br />
                  <label className={classe.selectLabel}>
                    Size-MM: <strong>{parentDes}</strong>
                  </label>
                  <br />
                  <label className={classe.selectLabel}>
                    <strong>{`D${imageObject.imgId}/P${simpleSelectProd}/C${crtId}`}</strong>
                  </label>
                  <br />
                  <div className="fileinput text-center">
                    <div
                      className={"thumbnail" + (avatar ? " img-circle" : "")}
                    >
                      {/* <img src={i.cropImageUrl + "?id=" + i.id} alt="..." /> */}
                      <img src={imageId} alt="..." />
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>

        {cartDetails.metalIssue != true ? (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <GiWireCoil />
                </CardIcon>
                <h3
                  className={classes.cardIconTitle}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <small>
                    Metal & Ready Gram Per Piece (Box ₹ {metGramVal})
                  </small>

                  <div
                    className={
                      classesRadio.checkboxAndRadio +
                      " " +
                      classesRadio.checkboxAndRadioHorizontal
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isCheckedMetal}
                          onChange={(e) => setIsCheckedMetal(e.target.checked)}
                          checkedIcon={
                            <Check className={classesRadio.checkedIcon} />
                          }
                          icon={
                            <Check className={classesRadio.uncheckedIcon} />
                          }
                          classes={{
                            checked: classCheck.checkedRose,
                            root: classCheck.checkRoot,
                          }}
                        />
                      }
                      classes={{
                        label: classesRadio.label,
                        root: classesRadio.labelRoot,
                      }}
                      label=""
                    />
                  </div>
                </h3>
              </CardHeader>
              <CardBody>
                <h5 className={classes.cardIconTitle}>
                  <strong>
                    Metal Price ₹ {metals !== "" ? metals : metalPrice}
                    <br />
                    {metalDetails.title}
                  </strong>
                </h5>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="Metal"
                      id="metals"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="metals"
                      value={metals}
                      onChange={(e) => {
                        const { value } = e.target;
                        //   setMetals(value);

                        const cleanValue = cleanDecimalInput(value);
                        setMetals(cleanValue);

                        const gram = Number(metalGram || 0);
                        const pcs = Number(selectedPieceSets?.pcs || 0);
                        const box = Number(selectedBox?.box || 0);
                        const price = cleanValue
                          ? Number(cleanValue)
                          : Number(metalPrice || 0);

                        const newMet = gram * pcs * box * price;
                        setMetGramVal(newMet.toFixed(2));
                        //   if (value) {
                        //     let newMet =
                        //       metalGram *
                        //       selectedPieceSets?.pcs *
                        //       selectedBox?.box *
                        //       (parseInt(value) + metalDiff);
                        //     // console.log(newMet);
                        //     setMetGramVal(newMet.toFixed(2));
                        //   } else {
                        //     let newMet =
                        //       metalGram *
                        //       selectedPieceSets?.pcs *
                        //       selectedBox?.box *
                        //       (metalPrice + metalDiff);
                        //     setMetGramVal(newMet.toFixed(2));
                        //   }
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="Ready Gram"
                      id="readyGram"
                      // inputProps={{
                      //   placeholder: "Ready Gram",
                      // }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="readyGram"
                      value={readyGram}
                      onChange={(e) => setReadyGram(e.target.value)}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="Metal Gram"
                      id="metalGram"
                      // inputProps={{
                      //   placeholder: "Metal Gram",
                      // }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="metalGram"
                      value={metalGram}
                      onChange={(e) => {
                        const { value } = e.target;
                        //   setMetalGram(value);

                        const cleanValue = cleanDecimalInput(value);
                        setMetalGram(cleanValue);

                        const gram = Number(cleanValue || 0);
                        const pcs = Number(selectedPieceSets?.pcs || 0);
                        const box = Number(selectedBox?.box || 0);
                        const price = metals
                          ? Number(metals)
                          : Number(metalPrice || 0);

                        const newMet = gram * pcs * box * price;
                        setMetGramVal(newMet.toFixed(2));
                        //   if (value) {
                        //     let newMet =
                        //       value *
                        //       selectedPieceSets?.pcs *
                        //       selectedBox?.box *
                        //       (metalPrice + metalDiff);
                        //     setMetGramVal(newMet.toFixed(2));
                        //   }
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="Extra S Gram"
                      id="metalSGram"
                      // inputProps={{
                      //   placeholder: "Metal S Gram",
                      // }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="metalSGram"
                      value={metalSGram}
                      onChange={(e) => setMetalSGram(e.target.value)}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="Thaw Golwire"
                      id="golwireThaw"
                      // inputProps={{
                      //   placeholder: "Golwire Thaw",
                      // }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="golwireThaw"
                      value={golwireThaw}
                      onChange={(e) => setGolwireThaw(e.target.value)}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        ) : (
          ""
        )}

        {cartDetails.lbrIssue != true ? (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <FaUsers />
                </CardIcon>
                <h3
                  className={classes.cardIconTitle}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <small>Making Charge Per (Box : ₹ {makVal.toFixed(2)})</small>
                  <div
                    className={
                      classesRadio.checkboxAndRadio +
                      " " +
                      classesRadio.checkboxAndRadioHorizontal
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isCheckedMaking}
                          onChange={(e) => setIsCheckedMaking(e.target.checked)}
                          checkedIcon={
                            <Check className={classesRadio.checkedIcon} />
                          }
                          icon={
                            <Check className={classesRadio.uncheckedIcon} />
                          }
                          classes={{
                            checked: classCheck.checkedRose,
                            root: classCheck.checkRoot,
                          }}
                        />
                      }
                      classes={{
                        label: classesRadio.label,
                        root: classesRadio.labelRoot,
                      }}
                      label=""
                    />
                  </div>
                </h3>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {lbrChild?.map((making, index) => {
                    const childId = making.id || making.lbrId;
                    const isChecked = making.checked === true;

                    return (
                      <GridItem xs={12} sm={6} md={4} key={childId || index}>
                        <div
                          style={{
                            border: isChecked
                              ? "1px solid #d81b60"
                              : "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Checkbox
                              checked={isChecked}
                              onChange={() => handleCheckBoxMaking(making)}
                              checkedIcon={
                                <Check className={classCheck.checkedIcon} />
                              }
                              icon={
                                <Check className={classCheck.uncheckedIcon} />
                              }
                              classes={{
                                checked: classCheck.checkedRose,
                                root: classCheck.checkRoot,
                              }}
                            />

                            <label
                              style={{
                                color: isChecked ? "#d81b60" : "",
                                fontWeight: isChecked ? "bold" : "normal",
                                flex: 1,
                              }}
                            >
                              {making.title} - ₹{" "}
                              {inputValues[childId] ?? making.price}
                            </label>

                            <CustomInput
                              id={"making-price-" + childId}
                              formControlProps={{
                                style: { margin: 0, width: "90px" },
                              }}
                              value={String(
                                inputValues[childId] ?? making.price ?? "",
                              )}
                              onChange={(e) => {
                                handleCheckboxInputChild(
                                  childId,
                                  e.target.value,
                                );
                              }}
                              inputProps={{
                                style: { textAlign: "center" },
                              }}
                            />
                          </div>
                        </div>
                      </GridItem>
                    );
                  })}
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        ) : (
          ""
        )}

        {cartDetails.pkgIssue != true ? (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <GiBoxUnpacking />
                </CardIcon>
                <h3
                  className={classes.cardIconTitle}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <small> Packing Option (Box ₹ {packVal})</small>
                  <div
                    className={
                      classesRadio.checkboxAndRadio +
                      " " +
                      classesRadio.checkboxAndRadioHorizontal
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isCheckedPacking}
                          onChange={(e) =>
                            setIsCheckedPacking(e.target.checked)
                          }
                          checkedIcon={
                            <Check className={classesRadio.checkedIcon} />
                          }
                          icon={
                            <Check className={classesRadio.uncheckedIcon} />
                          }
                          classes={{
                            checked: classCheck.checkedRose,
                            root: classCheck.checkRoot,
                          }}
                        />
                      }
                      classes={{
                        label: classesRadio.label,
                        root: classesRadio.labelRoot,
                      }}
                      label=""
                    />
                  </div>
                </h3>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "15px",
                      }}
                    >
                      <label style={{ flex: 1, margin: 0 }}>
                        {cartDetails.boxBrandName} - ₹ {cartDetails.boxPrice}
                      </label>

                      <div style={{ width: "100px" }}>
                        <CustomInput
                          id="boxInput"
                          formControlProps={{
                            fullWidth: true,
                            style: { margin: 0 },
                          }}
                          name="boxInput"
                          value={boxInput}
                          onChange={(e) => {
                            setBoxInput(cleanDecimalInput(e.target.value));
                          }}
                        />
                      </div>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "15px",
                      }}
                    >
                      <label style={{ flex: 1, margin: 0 }}>
                        {cartDetails.boxDesc} Packing Charge - ₹{" "}
                        {cartDetails.boxPkgCharge}
                      </label>

                      <div style={{ width: "100px" }}>
                        <CustomInput
                          id="boxPkgCharge"
                          formControlProps={{
                            fullWidth: true,
                            style: { margin: 0 },
                          }}
                          name="boxPkgCharge"
                          value={boxPkgCharge}
                          onChange={(e) => {
                            setBoxPkgCharge(cleanDecimalInput(e.target.value));
                          }}
                        />
                      </div>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <strong>{packingOption}</strong>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "15px",
                      }}
                    >
                      <label style={{ flex: 1, margin: 0 }}>
                        {packingOption === "Plastic Dibbi"
                          ? `${plasticDesc} - ₹ ${plasticPrice}`
                          : packingOption === "Crystal Dibbi"
                          ? `${crystalDesc} - ₹ ${crystalPrice}`
                          : packingOption === "Polythene Bag"
                          ? `${ployDesc} - ₹ ${ployPrice}`
                          : ""}
                      </label>

                      <div style={{ width: "100px" }}>
                        <CustomInput
                          id="packingPrice"
                          formControlProps={{
                            fullWidth: true,
                            style: { margin: 0 },
                          }}
                          name="packingPrice"
                          value={packingPrice}
                          onChange={(e) => {
                            setPackingPrice(cleanDecimalInput(e.target.value));
                          }}
                        />
                      </div>
                    </div>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        ) : (
          ""
        )}

        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <FaUsers />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Select Labour</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <label className={classe.selectLabel}>
                    Select Company & Client Name
                  </label>
                  <Selects
                    styles={customStyles}
                    style={select}
                    required={true}
                    placeholder="Select Company & Client Name..."
                    value={simpleSelectClient}
                    name="simpleSelectClient"
                    onChange={handleClient}
                    options={
                      itemClient &&
                      itemClient.map((c) => {
                        return {
                          label:
                            c && c.company
                              ? c.company + "-" + c.mobile
                              : c.firstname + " " + c.lastname + "-" + c.mobile,
                          value:
                            c && c.company
                              ? c.company + "-" + c.mobile
                              : c.firstname + " " + c.lastname + "-" + c.mobile,
                        };
                      })
                    }
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <div style={mystyle}>
        <Button
          color="rose"
          disabled={btn}
          onClick={SubmitLeadsAdd}
          className={classes.updateProfileButton}
        >
          {btn ? "Added" : "Add"}
        </Button>
      </div>
    </div>
  );
}

LeadsAdd.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
